const formatDurationUnit = (value: number, singular: string, plural: string): string =>
  `${value} ${value === 1 ? singular : plural}`

/** Up to two day/hour/minute units; never pairs seconds with a larger unit. */
export const formatDurationSeconds = (seconds: number): string => {
  const totalSeconds = Math.floor(seconds)

  if (totalSeconds <= 0) {
    return '0 seconds'
  }

  const days = Math.floor(totalSeconds / 86_400)
  const hours = Math.floor((totalSeconds % 86_400) / 3_600)
  const minutes = Math.floor((totalSeconds % 3_600) / 60)
  const remainingSeconds = totalSeconds % 60

  if (days > 0) {
    const parts = [formatDurationUnit(days, 'day', 'days')]
    if (hours > 0) {
      parts.push(formatDurationUnit(hours, 'hour', 'hours'))
    }
    return parts.join(', ')
  }

  if (hours > 0) {
    const parts = [formatDurationUnit(hours, 'hour', 'hours')]
    if (minutes > 0) {
      parts.push(formatDurationUnit(minutes, 'minute', 'minutes'))
    }
    return parts.join(', ')
  }

  if (minutes > 0) {
    return formatDurationUnit(minutes, 'minute', 'minutes')
  }

  return formatDurationUnit(remainingSeconds, 'second', 'seconds')
}
